import { render, staticRenderFns } from "./ProjectSettingBankAccount.vue?vue&type=template&id=2ad5d2dd"
import script from "./ProjectSettingBankAccount.vue?vue&type=script&lang=js"
export * from "./ProjectSettingBankAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports